let timeout = null;

async function j360SearchSubmit(event, spinnerText, noResultsText) {
  event.preventDefault();
  return j360Search(event.target.value, spinnerText, noResultsText);
}

async function j360Search(value, spinnerText, noResultsText) {

  // show search results by adding "show" class. check first if it already has the class

  j360SearchStartSpinner(spinnerText);
  const searchValue = value;
  const response = await fetch(`/wp-json/j360/v1/search?search=${searchValue}`);
  const data = await response.json();
  j360SearchUpdateResults(data, noResultsText);
}

function j360SearchStartSpinner(spinnerText) {
  const spinner = document.createElement('div');
  spinner.classList.add('j360-spinner');
  spinner.textContent = spinnerText;

  // get all search results
  const searchResultLocations = document.querySelectorAll('#j360-search-results');

  for (const searchResults of searchResultLocations) {
    if (!searchResults.classList.contains('show')) {
      searchResults.classList.add('show');
    }
    searchResults.innerHTML = '';
    searchResults.appendChild(spinner);
  }
}

function j360SearchUpdateResults(data, noResultsText) {
  const searchResultLocations = document.querySelectorAll('#j360-search-results');
  for (const searchResults of searchResultLocations) {
    searchResults.innerHTML = '';
    // data.forEach((item) => {
    //   const li = document.createElement('li');
    //   li.innerHTML = item.title;
    //   searchResults.appendChild(li);
    // });
    data.forEach((item) => {
      const li = document.createElement('li');
      // add an anchor tag
      const a = document.createElement('a');
      a.href = item.link;
      a.innerHTML = item.title;
      li.appendChild(a);
      searchResults.appendChild(li);
    });
    if (data.length === 0) {
      const li = document.createElement('li');
      li.textContent = noResultsText;
      searchResults.appendChild(li);
    }
  }
}

function j360SearchHideResults() {
  const searchResultLocations = document.querySelectorAll('#j360-search-results');
  for (const searchResults of searchResultLocations) {
    searchResults.classList.remove('show');
  }
}

function j360SearchShowResults() {
  const searchResultLocations = document.querySelectorAll('#j360-search-results');
  for (const searchResults of searchResultLocations) {
    if (!searchResults.classList.contains('show')) {
      searchResults.classList.add('show');
    }
  }
}


function j360SearchClearResults() {
  const searchResultLocations = document.querySelectorAll('#j360-search-results');
  for (const searchResults of searchResultLocations) {
    searchResults.innerHTML = '';
    searchResults.classList.remove('show');
  }
}

function j360SearchOnInput(event, spinnerText, noResultsText) {
  if (event.target.value.length === 0) {
    j360SearchClearResults();
    return;
  }
  j360SearchStartSpinner(spinnerText);

  clearTimeout(timeout);
  timeout = setTimeout(async () => {
    j360Search(event.target.value, spinnerText, noResultsText);
  }, 300);
}

function j360SearchOnBlur() {
  // hide search results
  setTimeout(() => {
    j360SearchHideResults();
  }, 300);
}

function j360SearchOnFocus(spinnerText) {
  // show search results
  j360SearchShowResults(spinnerText);
}

window.j360SearchOnInput = j360SearchOnInput;
window.j360SearchOnBlur = j360SearchOnBlur;
window.j360SearchOnFocus = j360SearchOnFocus;
window.j360SearchClearResults = j360SearchClearResults;
window.j360SearchHideResults = j360SearchHideResults;
window.j360SearchShowResults = j360SearchShowResults;
window.j360SearchStartSpinner = j360SearchStartSpinner;
window.j360SearchUpdateResults = j360SearchUpdateResults;
window.j360SearchSubmit = j360SearchSubmit;
window.j360Search = j360Search;